import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const BatteryIcon: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <svg
        className={`${className} ${styles.batteryIcon}`}
        data-testid={testId}
        fill='none'
        height='22'
        viewBox='0 0 32 22'
        width='32'
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M8.04208 11.6302C8.29001 11.1201 16.8445 0.344815 17.1544 0.0897665C17.4644 -0.165282 17.9603 0.15352 17.7743 0.6636C17.5883 1.17368 15.4187 8.31471 15.4187 8.31471H19.448C20.5019 8.31471 20.8738 8.82478 20.6878 9.5899C20.5018 10.355 11.6994 21.1941 11.3895 21.7042C11.0796 22.2142 10.3977 22.0229 10.5216 21.4491C10.6456 20.8753 13.0012 13.0967 13.0012 13.0967H9.0339C8.04212 13.0967 7.79415 12.1403 8.04208 11.6302Z'
            fill='currentColor'
        />

        <path
            d='M30.5999 14.5273H28.6664V7.37531H30.5999V14.5273ZM27.2663 14.6984L27.2667 14.7311C27.2835 15.4153 27.8291 15.9646 28.4997 15.9646H30.7666L30.7984 15.9642C31.4649 15.9469 32 15.3868 32 14.6984V7.2042C32 6.51586 31.4649 5.95579 30.7984 5.93845L30.7666 5.93805H28.4997C27.8185 5.93805 27.2663 6.50493 27.2663 7.2042V14.6984Z'
            fill='currentColor'
        />

        <path
            d='M11.5261 4.81098H2.00213C1.67042 4.81098 1.40146 5.08755 1.40144 5.42861V16.5448C1.40144 16.8858 1.67041 17.1624 2.00213 17.1624H10.3247L9.93399 18.6034H2.00213C0.896405 18.6034 0 17.6817 0 16.5448V5.42861C1.29239e-05 4.30059 0.88245 3.38444 1.97624 3.37019L2.00213 3.37H12.6187L11.5261 4.81098Z'
            fill='currentColor'
        />

        <path
            d='M26.6203 3.37019C27.7141 3.38446 28.5964 4.3006 28.5964 5.42861V16.5448C28.5964 17.6817 27.7001 18.6034 26.5944 18.6034H15.5174L16.61 17.1624H26.5944C26.9261 17.1624 27.195 16.8858 27.195 16.5448V5.42861C27.195 5.08756 26.9261 4.81099 26.5944 4.81098H17.9786L18.3693 3.37H26.5944L26.6203 3.37019Z'
            fill='currentColor'
        />
    </svg>
);

export default BatteryIcon;
